import React, { useEffect, useState } from 'react'
import PlantillaScreen from '../../helpers/PlantillaScreen'
import request from '../../../Helpers/API';
import Swal from 'sweetalert2';
import CreateIcon from '@mui/icons-material/Create';
import { Autocomplete, Button, MenuItem, TextField } from '@mui/material';
import ModalAgregarMenu from './ModalAgregarMenu';
import SearchIcon from '@mui/icons-material/Search';
import { GetKey, GetText } from '../../../Helpers/GetKey';

export const MenusScreen = () => {
  const [data, setData] = useState([]);
  const [modulos, setModulos] = useState([]);
  const [buscarModulo, setbuscarModulo] = useState(0);
  const [nombreModulo, setNombreModulo] = useState("")
  const [openModal, setOpenModal] = useState(false);
  const [id, setId] = useState({
    idmenu: -999,
    idmodulo: buscarModulo,
    modulo:"",
  })
  const [state, setState] = useState({
    moduloselect: "",
    modulosearch: "",
    titulosolicitud: "SELECCIONAR USUARIO",
    idusuario: 0,
  });
console.log(data)
  const handleOpenModal = (idmenu, idmodulo,modulo,ruta) => {
    if (idmenu === null || idmenu === 0 || idmenu === ""||idmodulo === null || idmodulo === 0 || idmodulo === "") {
      Swal.fire({
        title: "AGREGAR MENU",
        text: "Seleccione un modulo primero",
        icon: "error",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return;
    }
    else {
      setOpenModal(true);
      setId({ ...id, idmenu: idmenu, idmodulo: idmodulo,modulo:modulo, ruta:ruta})
    }

  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const onBuscar = () => {
    const modulo = GetText(state.modulosearch)
    const idmodulo = GetKey(state.modulosearch)
    if (idmodulo === null || idmodulo === 0 || idmodulo === "") {
      Swal.fire({
        title: "PERMISOS USUARIOS",
        text: "Seleccione un usuario",
        icon: "error",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return;
    }
    else {
      setbuscarModulo(idmodulo)
      setNombreModulo(modulo)
    }

  }
  useEffect(() => {
    // setLoader({ ...loader, mostrar: true });
    request
      .get(`Menu/ListadoMenus?idmodulo=${buscarModulo}`)
      .then((result) => {
        // setLoader({ ...loader, mostrar: false });
        setData(result)

      })
      .catch((error) => {
        // setLoader({ ...loader, mostrar: false });
        Swal.fire("LISTADO MENU", JSON.stringify(error), "error");
      });
  }, [buscarModulo]);

  useEffect(() => {
    request
      .get("Menu/DropDownList")
      .then((result) => {
        setModulos(result);
      })
      .catch((error) => {
        JSON.stringify("PERMISOS", "ERROR....", "error");
      });
  }, []);

  return (
    <PlantillaScreen
      titulo={"MENUS"}
      className_main={1}
      className={"configuracion-menus-main-screen"}
    >
      <div>
        <div className='configuraciones-menus-opciones-encabezado'>
          <div className='configuracion-menus-opciones-container'>
            <div className='configuracion-menus-input-buscar-modulo'>
              <Autocomplete
                size="small"
                id="dash-razonsocial"
                freeSolo
                // className="dash-cliente-search-razonsocial"
                value={state.usuariosearch}
                onChange={(_, newValue) => {
                  setState({ ...state, modulosearch: newValue });
                  // Navigate to the selected user route
                }}
                options={modulos.map(
                  (option) => `${option.id} - ${option.display}`
                )}
                renderInput={(params) => (
                  <TextField {...params} label="Selecciona un Modulo... " />
                )}

              />
            </div>
            <div className='permisos-usuarios-botones-container'>
              <Button
                variant="contained"
                sx={{ height: 35 }}
                className='permisos-usuario-boton-buscar-usuario'
                // onClick={handleOpenModal}
                onClick={() => onBuscar()}
              >
                <SearchIcon />
              </Button>
              <Button
                variant="contained"
                className='permiso-usuario-boton-agregar-nuevo-usuario'
                // onClick={handleOpenModal}
                // onClick={() => onAgregar()}
                onClick={() => handleOpenModal(-999, buscarModulo,nombreModulo)}
              >
                {/* <PersonIcon /> */}
                Agregar
              </Button>
            </div>
          </div>
        </div>
        {buscarModulo !== null && buscarModulo !== 0 && buscarModulo !== "" ? (
          <div className="configuracion-listado-menus-Container">
            <div className='configuracion-tabla-listado-menus scroll-4'>
              <table>
                <thead>
                  <tr>
                    <th>
                      Módulo
                    </th>
                    <th>
                      <div>Menú</div>
                    </th>
                    <th>
                      <div>Nomenclatura</div>
                    </th>
                    <th>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((menu) => (
                    <tr>
                      <td>{menu.modulo}</td>
                      <td>{menu.descripcion}</td>
                      <td>{menu.nomenclatura}</td>
                      <td>
                        <CreateIcon
                          onClick={() => handleOpenModal(menu.idmenu, menu.idmodulo,menu.modulo,menu.ruta)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (<div></div>)}

      </div>
      <ModalAgregarMenu modulos={modulos} open={openModal} handleClose={handleCloseModal} datos={id} setDatos={setId} />
    </PlantillaScreen>
  )
}


